import { isMeinBuero } from '@/utils/build-env'
import lang from '@/lang'
import validateCompanyName from './validateCompanyName'
import validateName from './validateName'
import validatePhoneNumber from './validatePhoneNumber'
import InputNames from '@/modules/onboardingV2/constants/input-names'

const validateInputs = (name: InputNames, value: string): string => {
  if (!isMeinBuero()) { return }

  switch (name) {
    case InputNames.firstName: {
      const isValid = validateName(value)
      return isValid ? '' : lang.onboardingV2.user.errors.name
    }
    case InputNames.lastName: {
      const isValid = validateName(value)
      return isValid ? '' : lang.onboardingV2.user.errors.name
    }
    case InputNames.companyName: {
      const isValid = validateCompanyName(value)
      return isValid ? '' : lang.onboardingV2.user.errors.name
    }
    case InputNames.phone1: {
      const isValid = validatePhoneNumber(value)
      return isValid ? '' : lang.onboardingV2.user.errors.phone
    }
  }
}

export default validateInputs
